import { useRuntimeConfig } from "#imports";
export default function useBoosterConfig() {
  const { booster: runtimeConfig } = useRuntimeConfig().public;
  return runtimeConfig;
}
